import TambahListDataMitraGudang from './TambahListMitraGudang.vue'

export default TambahListDataMitraGudang
